
const GoogleRegisteredHostnames = {
  vdmplayer: 'vdmplayer.codev8.net',
  democdnplayer: 'democdnplayer.codev8.net',
  cdnapi: 'cdnapi.codev8.net',
};

const Credentials = {
  GoogleMapsApiKey: 'AIzaSyBzyrrHDnZEnyk3VGvSdFjJWdLvhOlu7xg',
  Chat: {
    GoogleIds: {                      // NOTE Login with google
      [GoogleRegisteredHostnames.vdmplayer]: '608999539073-51s2o1r5puqkeu72uv5ik2iorec50948.apps.googleusercontent.com',
      [GoogleRegisteredHostnames.democdnplayer]: '608999539073-4c74a3sm71i0f6ek7auldqmel2n4tdn7.apps.googleusercontent.com',
      [GoogleRegisteredHostnames.cdnapi]: '608999539073-a1vgv9tk3n2rggi4fgdr9oe675fp8urr.apps.googleusercontent.com',
    },
    FacebookAppId: '191063691515498',    // NOTE Login with facebook
  },
  Custom_3_playerLicenseKey: 'custom-3-license-key',
  THEOplayerLicenseKey: 'sZP7IYe6T6fZ3KCi3D0zTmkKIQfLFSa_IQa-CSXe3Zzt3L31ISXeIuxK0Qh6FOPlUY3zWokgbgjNIOf9fl5L0oIlCle_FS160uR-3uRrTOz_3lI6FSeoIl0LCSIg0ueZC6fVfK4_bQgZCYxNWoryIQXzImf90SCtTS0i3lai0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3lb_0LbLTue_TSfoFOPeWok1dDrLYtA1Ioh6TgV6v6fVfKcqCoXVdQjLUOfVfGxEIDjiWQXrIYfpCoj-fgzVfKxqWDXNWG3ybojkbK3gflNWf6E6FOPVWo31WQ1qbta6FOPzdQ4qbQc1sD4ZFK3qWmPUFOPLIQ-LflNWfK1zWDikfgzVfG3gWKxydDkibK4LbogqW6f9UwPkImi6IK41Uw4ZIY06Tg-Uya',
  // THEOplayerLicenseKey: 'sZP7IYe6T6fLCKx60SUKTOzrIl5tFSaL3la-TSB_0OzkTuCr3Q4e0oI13LC6FOPlUY3zWokgbgjNIOf9fl5L0oIlCle_FS160uR-3uRrTOz_3lI6FSeoIl0LCSIg0ueZC6fVfK4_bQgZCYxNWoryIQXzImf90Sbt3Lhz0Lfi0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3L5r3l0r3SCc3ShiFOPeWok1dDrLYtA1Ioh6TgV6v6fVfKcqCoXVdQjLUOfVfGxEIDjiWQXrIYfpCoj-fgzVfKxqWDXNWG3ybojkbK3gflNWf6E6FOPVWo31WQ1qbta6FOPzdQ4qbQc1sD4ZFK3qWmPUFOPLIQ-LflNWfK1zWDikfgzVfG3gWKxydDkibK4LbogqW6f9UwPkImi6IK41Uw4ZIY06Tg-Uya',
      // esta segunda es la que se supone que esta usando tyris para web
  // S73ApiKey: 'wY31QiIMpBchn3PtSLVXgQKJKkA8mcFDW5lKdZOg9TuQ0Jwo4ylG5n5XqkUPGMrFfw0xTJmC6CVBrbySp2IQ1IKA=',
  S73ApiKey: 'eyJoYXNoZWRfa2V5IjoiTGhYUkt3NnJPcVlaNWQwNUE3VHJhakpyZjVQLVE4Tl8yeW1pV3hBSlhtTSIsInNpZ25hbF9zZXJ2ZXJfdXJsIjoid3NzOlwvXC9jZXJiZXJ1cy5lbWVhLnBvbHluZXQuczczY2xvdWQuY29tOjQ0M1wvd3MiLCJzdHVuX3NlcnZlcl91cmwiOlsic3R1bjpzdHVuLWVtZWEtMDEuczczY2xvdWQuY29tOjM0NzgiLCJzdHVuOnN0dW4tZW1lYS0wMi5zNzNjbG91ZC5jb206MzQ3OCJdLCJtZXRyaWNfc2lua191cmwiOiJodHRwczpcL1wvY2VyYmVydXMuZW1lYS5wb2x5bmV0LnM3M2Nsb3VkLmNvbTo0NDNcL21ldHJpY3NcL3YxIn0=',
};

const BasePath = process.env.PUBLIC_URL;
const ResourcesPath = `${BasePath}/resources`;
const PresetConfigurationsBasePath = `${BasePath}/preset-configurations`;
const SelfHostedExternalSrcBasePath = `${BasePath}/self-hosted-external-src`;

export const EnvironmentsKeys = {
  development: 'development',
  default: 'default',
};

export const DomainsKeys = {
  CMS: 'CMS',
  Configuration: 'Configuration',
  Stats: 'Stats',
};

const ExternalConfiguration = {
  Credentials,
  EnvDomains: {
    [EnvironmentsKeys.development]: {
      [DomainsKeys.CMS]: 'https://cdnapi.codev8.net',
      [DomainsKeys.Configuration]: 'https://cdnapi.codev8.net',
      [DomainsKeys.Stats]: 'https://maquina.codev8.net',
    },
    [EnvironmentsKeys.default]: {
      [DomainsKeys.CMS]: '//cdnapi.codev8.net',
      [DomainsKeys.Configuration]: '//cdnapi.codev8.net',
      [DomainsKeys.Stats]: 'https://stats.codev8.net',
    },
  },
  CMSApiBasePath: '/apicloud/v1.0',
  BasePath,
  ResourcesPath,
  DefaultBlockedContentImage: `${ResourcesPath}/default-blocked-content-image.png`,
  DefaultDownloadButtonImage: `${ResourcesPath}/default-download-button-image.svg`,
  DefaultImageDown: `${ResourcesPath}/default-image-down.jpg`,
  DefaultErrorVideo: `${ResourcesPath}/default-error-video.mp4`,
  PresetConfigurationsPaths: {
    'test-custom-4': `${PresetConfigurationsBasePath}/test.custom.4.json`,
    'test-bradmax': `${PresetConfigurationsBasePath}/test.bradmax.json`,
    'test-theoplayer': `${PresetConfigurationsBasePath}/test.theoplayer.json`,
    'default.iframe': `${PresetConfigurationsBasePath}/default.iframe.json`,
    'tagging-default.iframe': `${PresetConfigurationsBasePath}/tagging-default.iframe.json`,
  },
  SelfHostedExternalSrcPaths: {
    custom_3_player: `${SelfHostedExternalSrcBasePath}/custom-3`,
    custom_4_player: `${SelfHostedExternalSrcBasePath}/custom-4`,
    THEOplayer: `${SelfHostedExternalSrcBasePath}/theoplayer`,
    Bradmax: `${SelfHostedExternalSrcBasePath}/bradmax`,
    s73: `${SelfHostedExternalSrcBasePath}/s73`,
  },
  Custom3PlayerDefaults: {
    aboutText: 'About Flumotion',
    aboutLink: '//www.flumotion.com',
    skin: {
      controlbar: {
        text: 'rgba( 255, 255, 255, 1)',
        icons: 'rgba( 255, 255, 255, 0.8)',
        iconsActive: 'rgba( 255, 255, 255, 1)',
        background: 'rgba( 0, 0, 0, 0)',
      },
      timeslider: {
        progress: 'rgba( 242, 242, 242, 1)',
        rail: 'rgba( 255, 255, 255, 0.3)',
      },
      menus: {
        text: 'rgba( 255, 255, 255, 0.8)',
        textActive: 'rgba( 255, 255, 255, 1)',
        background: 'rgba( 51, 51, 51, 1)',
      },
      tooltips: {
        text: 'rgba( 0, 0, 0, 1)',
        background: 'rgba( 255, 255, 255, 1)',
      },
    },
  },
  TaggingDefaults: {
    widthFactor: 0.64,
    transcriptionUrlLabel: 'ES',
  },
  ChatDefaults: {
    refreshInterval: 10*1000,
    widthFactor: 0.7,
  },
  Analytics: {
    google: {
      googletagmanagerBasePath: 'https://www.googletagmanager.com/gtag/js',
    },
    custom: {
      endpointBasePath: 'https://analytics-api-pre.flumotion.cloud',
    },
  },
};

export default ExternalConfiguration;
